<template>
    <article class="home">
        <section class="hero flex">
            <div class="graphic"></div>
            <div class="ff details flex flex-column flex-center">
                <img src="@/assets/logo-grey.svg" class="logo" />
                <div class="ff tagline flex flex-column flex-center">
                    <h1>Get started with the Simulation Curriculum interactive textbook platform.</h1>
                    <div class="flex flex-align login-options">
                        <template v-if="authenticated">
                            <router-link class="button" :to="{name: 'library'}">Continue To Your Library</router-link>
                        </template>
                        <template v-else>
                            <div class="button" @click="login">Sign In</div>
                            <router-link class="button grey" :to="{name: 'about'}">Learn More</router-link>
                        </template>
                    </div>
                </div>
                <div class="flex flex-align">
                    <a class="disclaimer" href="https://cdn.shopify.com/s/files/1/0087/9052/files/EULA_-_SN_SS_TLE.pdf"
                        target="_blank">Terms of Service</a>
                    <a class="disclaimer" href="https://store.simulationcurriculum.com/pages/privacy-policy"
                        target="_blank">Privacy Policy</a>
                </div>
            </div>
        </section>
    </article>
</template>

<script>
const url = process.env.VUE_APP_APPLICATION_URL;
console.log('APP URL: ', process.env.VUE_APP_APPLICATION_URL);

export default {
    name: 'Home',
    computed: {
        authenticated() {
            return this.$store.state.user.user_id;
        }
    },
    methods: {
        serialize(object) {
            const str = [];

            for (const [key, value] of Object.entries(object)) {
                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            }

            return str.join('&');
        },
        login() {
            // Construct the authorization URL.
            // This information comes from the Edlink dashboard:
            // https://ed.link/simcur/applications/9dd97a42-b66b-46d0-a349-e183286f3568/keys
            //
            // You can find more information about Edlink authentication here:
            // https://ed.link/docs/guides/v2.0/authorization

            const parameters = {
                client_id: '9dd97a42-b66b-46d0-a349-e183286f3568',
                redirect_uri: `${url}/api/login`,
                state: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            };

            // Redirect the user to Edlink for sign in.
            window.location = `https://ed.link/sso/login?${this.serialize(parameters)}`;
        }
    }
}
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

@provider-background-color: @f;

section {
    .constrain {
        padding: 100px 50px;
    }
}

h1 {
    color: var(--primary-text-color);
}

h3 {
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 40px;
    color: var(--primary-text-color);
}

h4 {
    margin-bottom: 30px;
    text-transform: uppercase;
    color: var(--secondary-text-color);
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
}

.logo {
    width: 80px;
    margin-bottom: 30px;
    opacity: 0.5;
}

.hero {
    height: 100vh;

    .graphic {
        background: url('~@/assets/eagle.jpg') center center no-repeat;
        background-size: cover;
        flex: 0.5;
    }

    .details {
        padding: 80px 100px;
        border-left: 1px solid var(--border-color);
    }

    .login-options {
        margin-top: 30px;
        margin-bottom: 100px;

        .button {
            margin-right: 20px;
            min-width: 120px;
        }
    }

    .tagline {
        max-width: 550px;
    }

    .disclaimer {
        color: var(--secondary-text-color);
        font-size: 13px;
        margin-right: 20px;
        text-decoration: none;
        border: 0;

        &:hover,
        &:active {
            color: var(--primary-text-color);
        }
    }
}
</style>
